<!-- 添加套卷 -->
<template>
  <div class="addCoiling">
    <div ref="coilingBox" class="coilingBox" @scroll="scrollFn($event)">
      <ul ref="coilingList" id="coilingList" class="coilingList">
        <div
          v-show="isDisable"
          @click.stop="checkClick"
          style="
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 999;
            background: rgba(0, 0, 0, 0);
            pointer-events: auto;
          "
        ></div>
        <li
          v-for="(item, index) in coilingList"
          :key="item.id"
          @click="coilingClick(index, item.id)"
          @dblclick="coilingdblclick(index)"
          :class="{
            active: coilingListActive[index],
            activeBorder: contenteditableActive[index],
          }"
          :ref="item.id"
        >
          <div
            class="p"
            :class="{ gray: isDisable }"
            :contenteditable="contenteditableActive[index]"
            @blur="blurLi($event, item)"
            @focus="focusLi"
            @keydown="handleKeyDown"
          >
            <div class="name">
              {{ item.name }}
            </div>
            <div class="state" :class="translationStateItem(item.publish||0).type">
              {{ item.publishName||'未发布' }}
            </div>
          </div>

          <div class="unsaved" v-if="contentChangeId.includes(item.id)">*</div>
          <div
            class="deleteAddCoiling"
            @click="deleteAddCoiling(item.name, item.id)"
          >
            <img src="../../assets/images/icon-close.png" alt="" />
          </div>
        </li>
      </ul>
    </div>

    <!-- F0F2F5 -->
    <div class="scrollChange">
      <span @click="scrollLeft">
        <i
          :style="{ color: isScrollLeft ? 'rgba(0, 0, 0, 0.15)' : '#0BAE6A' }"
          class="el-icon-arrow-left"
        ></i>
      </span>
      <span @click="scrollRight">
        <i
          :style="{ color: isScrollRight ? 'rgba(0, 0, 0, 0.15)' : '#0BAE6A' }"
          class="el-icon-arrow-right"
        ></i>
      </span>
    </div>

    <div class="allCoiling">
      共<span>{{ coilingList.length }}</span>卷
    </div>
    <div class="addCoilingBtn" @click="addCoilingHandle">
      <img src="../../assets//images/icon-add.png" alt="" />
      新增
    </div>

    <el-dialog
      class="pubDialog"
      width="800rem"
      :title="`预览(${previewTitle})`"
      :visible.sync="pubDialogVisible"
    >
      <div class="pub-search">
        <el-input
          placeholder="请输入你需要的名称"
          suffix-icon="el-icon-search"
          v-model="pubName"
          @input="changePubName"
        >
        </el-input>
      </div>
      <div class="select-info">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        已选择 <span class="selected">{{ checkedPapers.length }}</span
        >/{{ coilingList.length }}
      </div>
      <el-table :data="cloneCoiList" border  @selection-change="handleSelectionChange" height="328rem">
        // :selectable="checkSelectable"
        <el-table-column type="selection" align="center" width="40" />
        <el-table-column prop="name" label="名称" header-align="center">
          <template slot-scope="scope">
            <el-tag effect="plain" size="small" style="margin-right: 8rem;" :type="translationStateItem(scope.row.publish||0).type">
              {{ scope.row.publishName||'未发布' }}
            </el-tag>
            <span class="text-ellipsis">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="140" align="center"></el-table-column>
      </el-table>

      <!-- <div class="paper-list">
        <div class="title">
          <div>名称</div>
          <div>更新时间</div>
        </div>
        <div style="height: 328rem; overflow: auto">
          <vue-scroll class="scrollContent" :ops="ops" ref="vueScrollBox">
            <div class="papers">
              <div class="paper-check">
                <el-checkbox-group
                  v-model="checkedPapers"
                  @change="handlePapersChange"
                >
                  <div
                    v-for="paper in cloneCoiList"
                    :key="paper.id"
                    class="name"
                  >
                    <el-checkbox :label="paper.id">
                      <div class="paper-name">
                        {{ paper.name }}
                        <div
                          class="unsave"
                          v-if="contentChangeId.includes(paper.id)"
                        >
                          未保存
                        </div>
                      </div>
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
              <div class="paper-time">
                <div v-for="paper in cloneCoiList" :key="paper.id" class="time">
                  {{ paper.updateTime }}
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div> -->

      <div slot="footer" class="dialog-footer">
        <el-button
          class="preserveHandle pub"
          type="primary"
          @click="handlePubPaper"
          >发布</el-button
        >
        <el-button class="preserveHandle" type="primary" @click="viewPaper"
          >预览</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      class="previewDialog"
      width="314px"
      title=""
      :visible.sync="previewDialogVisible"
    >
      <div
        slot="title"
        class="preview-header"
        @click="previewDialogVisible = false"
      >
        <i class="el-icon-back"></i>
      </div>
      <div class="coilingNum">
        共 <span>{{ checkedPapers.length }}</span> 套
      </div>
      <div class="coilingQrCode">
        <canvas
          style="width: 200px; height: 200px"
          ref="coilingqrcode"
        ></canvas>
      </div>
      <div class="coilingInfo">打开万唯中考APP扫码查看</div>
      <div class="coilingBtn">
        <el-button class="preserveHandle" type="primary" @click="handlePubPaper"
          >发布</el-button
        >
      </div>

      <div slot="footer" class="dialog-footer">
        <div class="logo"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from "@/utils/event-bus";
import { deleteCoiling, renameCoiling, publishCoiling } from "@/api/addModule";
import { isAddressType } from "@/constants/constants";
// import vueScroll from "vuescroll";
import { getAllModule} from '@/api/questionIndex'
import _ from "lodash";
import QRCode from "qrcode";
import { getPublishStatus } from "@/utils/util";

const TAG = "[addCoiling.vue] ";
// let timer2 = '';

export default {
  name: "AddCoiling",
  //components: { vueScroll },
  data() {
    return {
      TAG: "[addCoiling.vue] ",
      isScrollLeft: true, // 到达左侧
      isScrollRight: true, // 到达右侧

      coilingList: [], // 套卷列表
      coilingListActive: [true],
      contenteditableActive: [],
      historyName: "", // 套卷历史名称
      contentChangeId: [], // 未保持
      coilingId: 0,
      pubDialogVisible: false,
      pubName: "",
      isIndeterminate: true,
      checkedCount: 0,
      checkAll: false,
      checkedPapers: [],
      cloneCoiList: [],
      previewDialogVisible: false,
      regionName: "",
      previewTitle: "",
      bookType: "",
      specialType: "",
      listStatus: "ready",
      ops: {
        vueScroll: {},
        scrollPanel: {
          speed: 300,
        },
        rail: {
          opacity: "0.1",
          border: "1rem solid #f2f2f2",
          size: "3rem",
        },
        bar: {
          size: "4rem",
          background: "#D9D9D9",
          keepShow: true,
        },
      },
      isDisable: true,
      timer: "",
    };
  },

  computed: {
    fieldsJSON() {
      //解决监听新旧值一样的问题
      return JSON.parse(JSON.stringify(this.$store.state.fieldsJSON));
    },
  },
  props: {
    from: {
      type: String,
    },
    formData: {
      type: Object,
    },
  },
  methods: {
    // 控制每行复选框是否可选的函数
    checkSelectable(row) {
      return row.publish!=1
    },
    
    checkClick() {},
    getProgressEnd() {
      // this.isDisable = false;
      // clearTimeout(this.timer);
    },
    handlePubPaper() {
      if (this.checkedPapers.length == 0) {
        this.$message.error("请至少选项一套卷子 !");
        return;
      }
      let content = "";
      this.checkedPapers.forEach((items) => {
        const paper = _.find(this.coilingList, (item) => item.id == items.id);
        content += paper.name + "<br />";
      });
      this.$confirm(content, "确定发布?", {
        distinguishCancelAndClose: true,
        confirmButtonText: "发布",
        cancelButtonText: "取消",
        customClass: "pubConfirm",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.pubPaper();
        })
        .catch(() => {});
    },
    showPreview() {
      this.listStatus = "pending";
      this.$parent.getCoiling();
      // 等一秒显示
      setTimeout(() => {
        if (this.listStatus == "pending") {
          this.listStatus = "ready";
        }
      }, 1000);
    },
    changePubName(val) {
      if (val) {
        this.cloneCoiList = _.filter(this.coilingList, (v) => {
          return v.name.indexOf(val) != -1;
        });
      } else {
        this.cloneCoiList = this.coilingList;
      }
    },
    pubPaper() {
      // 发布接口
      publishCoiling(this.checkedPapers.map(item => item.id))
        .then((res) => {
          console.log(TAG, "publishCoiling res", res);
          if (res["code"] == 0) {
            const keys = Array.from({ length: sessionStorage.length }, (_, i) => sessionStorage.key(i));
            keys.forEach(key => {
              if (Number(key)) {
                sessionStorage.removeItem(key);
              }
            })

            this.$message({
              message: "发布成功！",
              type: "success",
            });
            this.pubDialogVisible = false;
            this.previewDialogVisible = false;
            EventBus.$emit("getCoiling");
          }else{
            this.$message({
              message: res.info,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(TAG, "blurLi err", err);
          this.$message({
            message: err,
            type: "error",
          });
        });
    },
    viewPaper() {
      console.log('--- viewPaper --->',this.checkedPapers);
      if (this.checkedPapers.length == 0) {
        this.$message.error("请至少选项一套卷子 !");
        return;
      }
      this.previewDialogVisible = true;
      this.$nextTick(() => {
        const canvas = this.$refs.coilingqrcode;
        const { bookId, region } = this.$route.query;

        const QrcodeInfo = {
          bookId,
          region,
          paperId: this.checkedPapers.map(item => item.id).join(","),
          bookType: this.bookType,
          specialType: this.specialType,
        };
        
        if(this.$store.state.pageNum=="2"){
          QrcodeInfo.bookType = "听说精练"
          QrcodeInfo.catalog = this.$route.query.type;
        }
        console.log(JSON.stringify(QrcodeInfo));
        QRCode.toCanvas(
          canvas,
          JSON.stringify(QrcodeInfo),
          { width: 200, height: 200, margin: 1.5, colorLight: "#ffffff00" },
          (error) => {
            if (error) console.error(error);
          }
        );
      });
    },
    handlePapersChange(val) {
      console.log(val);
    },
    handleCheckAllChange(val) {
      const valAll = this.coilingList.map((v) => {
        return v.id;
      });
      this.checkedPapers = val ? valAll : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      console.log(value);
      this.checkedCount = value.length;
      this.checkAll = this.checkedCount === this.coilingList.length;
      this.isIndeterminate =
        this.checkedCount > 0 && this.checkedCount < this.coilingList.length;
    },
    // 禁止换行
    handleKeyDown(event) {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    },

    // 新增套卷
    addCoilingHandle() {
      // 判断是否是"北京"  "题型专项训练"拦截
      if (isAddressType.isAddressType && !this.from) {
        this.$message.error("请先选择类型");
        return;
      }
      if (this.from === "special" && !this.formData.module) {
        this.$message.error("请先选择类型");
        return;
      }
      if (!this.$route.query.type && !this.$store.state.moduleType) {
        this.$message.error("请先选择类型");
        return;
      }

      // 调用父组件 - 新增套卷
      this.$parent.addCoilingHandle((id) => {
        // 新增套卷成功回调
        this.coilingListActive = [true];
        this.contenteditableActive = [];

        this.$message({
          message: "新增成功！",
          type: "success",
        });
        this.getModule();
        EventBus.$emit("disableModuleInput"); //用于禁用模块input框
        // 清空试题内容 参数：套卷id
        EventBus.$emit("addCoilingHandle", id);
      });
    },

    // 套卷名称点击事件
    coilingClick(index, id) {
      if (this.isDisable) {
        return;
      }
      
      
      if(this.coilingId != id){
        this.coilingId = id;
          this.isDisable = true;
      }
      this.timer = setTimeout(() => {
        this.isDisable = false;
      }, 1500);
      // setTimeout(()=>{
      console.log(this.TAG + index);
      if (this.coilingListActive[index]) return;

      this.contenteditableActive = [];
      this.coilingListActive = [];
      this.$set(this.coilingListActive, index, true);

      // 清空试题内容 参数：套卷id
      EventBus.$emit("addCoilingHandle", id);
      //this.$emit("getCollectionStatus", id);
      // },3000)
    },
    getModule(){
      getAllModule().then(res => {
        if(res.code == 0){
          sessionStorage.setItem('moduleData',JSON.stringify(res.data));
        }
      })
    },
    // 套卷名称双击事件
    coilingdblclick(index) {
      console.log(this.TAG + "双击");
      this.contenteditableActive = [];
      this.$set(this.contenteditableActive, index, true);
    },

    // 套卷名称失焦，保存名称
    blurLi(e, item) {
      console.log("🐞 - addCoiling.vue:502 - e :", e)
      const nameDiv = e.target.querySelector('.name');
      let innerHTML = nameDiv.innerHTML.trim();

      console.log(TAG + "套卷名称失焦blurLi", e.target.innerHTML, item);
      if (innerHTML.length > 8) {
        this.$message.error("套卷名称不能超过8个字,请重新命名！");
        this.contenteditableActive = [];
        return;
      }
      if (!innerHTML) {
        this.$message.error("套卷名称不能为空！");

        e.target.innerHTML = this.historyName;

        this.contenteditableActive = [];
        return;
      }

      // 名字不变情况
      if (this.historyName == innerHTML) {
        this.contenteditableActive = [];
        return;
      }

      // 重命名失败！
      const errFn = () => {
        e.target.innerHTML = this.historyName;
        this.$message.error("重命名失败！");
      };

      let data = {
        id: item.id,
        name: innerHTML,
      };

      // 重命名接口
      renameCoiling(data)
        .then((res) => {
          console.log(TAG, "blurLi res", res);
          if (res["code"] == 0) {
            this.$message({
              message: "重命名成功！",
              type: "success",
            });
            item.name = innerHTML;
            console.log(TAG, "blurLi coilingList", this.coilingList);
          } else {
            errFn();
          }
        })
        .catch((err) => {
          console.log(TAG, "blurLi err", err);
          errFn();
        });

      this.contenteditableActive = [];
    },

    // 套卷名称获得焦点，保存名称
    focusLi(e) {
      console.log(TAG + "套卷名称获得焦点focusLi");
      this.historyName = e.target.innerHTML.trim();
    },

    // 删除套卷
    deleteAddCoiling(name, id) {
      // 先弹框确认

      this.$confirm(`是否删除《${name}》?`, "删除提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "customClass",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          console.log(TAG + "deleteAddCoiling 删除套卷", id);

          // 删除套卷接口
          deleteCoiling(id)
            .then((res) => {
              console.log(TAG, "deleteAddCoiling res", res);
              if (res["code"] == 0) {
                this.contenteditableActive = [];

                console.log(
                  TAG,
                  "this.coilingList",
                  JSON.stringify(this.coilingList),
                  this.coilingList,
                  id
                );
                // 如果是最后一个，往前提一个
                let index = this.coilingList.findIndex((item) => item.id == id);

                console.log(TAG, "deleteAddCoiling resindex", index);
                if (index == this.coilingList.length - 1 && index != 0) {
                  this.coilingListActive = [];
                  this.coilingListActive[index - 1] = true;
                }
                if (index == 0 && this.coilingList.length == 1) {
                  this.coilingListActive = [];
                  EventBus.$emit("addCoilingHandle", ''); //用于清空流程和内容
                }

                // 获取套卷
                this.$parent.getCoiling();
                this.$message({
                  message: "删除套卷成功！",
                  type: "success",
                });
              } else {
                this.$message.error("删除套卷失败！");
              }
            })
            .catch((err) => {
              console.log(TAG, "deleteAddCoiling err", err);
              this.$message.error("删除套卷失败！");
            });
        })
        .catch(() => {});
    },

    // 点击滚动条向左
    scrollLeft() {
      // console.log(this.$refs.coilingBox.scrollLeft);
      this.$refs.coilingBox.scrollLeft = this.$refs.coilingBox.scrollLeft - 100;
    },

    // 点击滚动条向右
    scrollRight() {
      this.$refs.coilingBox.scrollLeft = this.$refs.coilingBox.scrollLeft + 100;
    },

    // 监听滚动条滚动, 显示点击左右高亮
    scrollFn() {
      let scrollLeft = this.$refs.coilingBox.scrollLeft;

      this.isScrollLeft = scrollLeft < 3;

      // 滚动条相差
      let scrollDifference =
        this.$refs.coilingList.scrollWidth - this.$refs.coilingBox.clientWidth;

      // console.log(
      //   "scrollDifference",
      //   scrollDifference,
      //   this.$refs.coilingList.scrollWidth,
      //   this.$refs.coilingBox.clientWidth
      // );

      this.isScrollRight = scrollLeft > scrollDifference - 3;
    },

    // 未存储-保存id
    contentChangeIdUn(id) {
      if (!this.contentChangeId.includes(id)) {
        this.contentChangeId.push(id);
        sessionStorage.setItem(
          "contentChangeId",
          JSON.stringify(this.contentChangeId)
        );
      }
    },
    // 存储-删除id
    contentChangeIdEnd(id) {
      if (!Array.isArray(this.contentChangeId)) return;
      const index = this.contentChangeId.findIndex(item => item === id);
      if (index !== -1) {
        this.contentChangeId.splice(index, 1);
        sessionStorage.setItem('contentChangeId', JSON.stringify(this.contentChangeId));
      }
    },
    setType(type) {
      this.bookType = type;
    },
    changeSpecialType(type) {
      this.specialType = type;
    },
    // 套卷发布状态
    translationStateItem(publish) {
      return getPublishStatus(publish);
    },
    // 套卷选中
    handleSelectionChange(val) {
      this.checkedPapers = val;
    },
  },
  mounted() {
    setTimeout(() => {
      this.isDisable = false;
    }, 1500);
    EventBus.$on("getProgressEnd", this.getProgressEnd);

    let sessionChangeId = sessionStorage.getItem("contentChangeId");
    this.contentChangeId = sessionChangeId ? JSON.parse(sessionChangeId) : [];

    let { bookId, region, questionSource, year, type } = this.$route.query;
    this.regionName = region;
    if (type) {
      this.previewTitle = `${type}-`;
    }
    this.previewTitle += `${questionSource}-${region}`;
    console.log("AddModule", bookId, region, questionSource, year);

    EventBus.$on("contentChangeIdUn", this.contentChangeIdUn);
    EventBus.$on("contentChangeIdEnd", this.contentChangeIdEnd);
    EventBus.$on("showPreview", this.showPreview);
    EventBus.$on("getType", this.setType);
    EventBus.$on("changeSpecialType", this.changeSpecialType);
  },

  // 销毁前
  beforeDestroy() {
    EventBus.$off("contentChangeIdUn", this.contentChangeIdUn);
    EventBus.$off("contentChangeIdEnd", this.contentChangeIdEnd);
    EventBus.$off("showPreview", this.showPreview);
    EventBus.$off("getType", this.setType);
    EventBus.$off("changeSpecialType", this.changeSpecialType);
    EventBus.$off("getProgressEnd", this.getProgressEnd);
  },

  watch: {
    fieldsJSON: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal);
        // this.getProgressEnd();
        // this.isDisable = false
        // clearTimeout(this.timer);
        // this.isDisabledSaveBtn = false;
      },
      deep: true,
      // immediate:true
    },
    coilingList: {
      handler: function (newUser) {
        console.log("coilingList生变化：", newUser);
        if (newUser.length) {
          this.coilingId = newUser[0].id;
          console.log("coilingList生变化：coilingId", this.coilingId);
          let index = this.coilingListActive.findIndex((item) => item);
          console.log("coilingList生变化：index", index);

          let id = index == -1 ? -1 : newUser[index].id;
          // 清空试题内容,重新加载内容 参数：套卷id
          EventBus.$emit("addCoilingHandle", id);
          this.$emit("getCollectionStatus", id);
          setTimeout(() => {
            this.scrollFn();
          }, 200);
        } else {
          EventBus.$emit("addCoilingHandle", -1);
        }
      },
      deep: true, // 设置 deep 选项为 true，实现深度监听
    },
    listStatus: {
      handler: function (val) {
        if (val == "ready") {
          this.cloneCoiList = this.coilingList;
          this.pubDialogVisible = true;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
$coilingPadding: 300rem;
.gray {
  color: gray;
  cursor: no-drop!important;
}
.scrollChange {
  width: 80rem;
  display: flex;
  justify-content: center;

  i {
    font-weight: 600;
  }

  span {
    width: 30rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
  }
}

.addCoiling {
  display: flex;
  flex-direction: row;
  border-bottom: 1rem solid #e9e9e9;
  width: calc(100% - 40rem);
  // padding-bottom: 4rem;
  align-items: center;
}

.coilingBox::-webkit-scrollbar {
  display: none;
}

.coilingBox {
  overflow: scroll;
  width: calc(100% - 239rem);
  padding: 8rem 0;
}

.coilingList {
  display: flex;
  flex-direction: row;
  // height: 34rem;

  li {
    white-space: nowrap;
    cursor: pointer;
    // user-select:none;
    position: relative;
    font-size: 14rem;
    color: #303133;
    margin-left: 4rem;
    // height: 32rem;
    // line-height: 31rem;
    border: 1rem solid rgba(0, 0, 0, 0);
    border-radius: 6rem;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    > .p {
      padding: 0rem 10rem;
      
      .state{
        font-size: 12rem;
        text-align: center;
      }
    }

    > .p:focus-visible {
      outline: none;
    }

    .deleteAddCoiling {
      width: 14rem;
      height: 14rem;
      position: absolute;
      right: -8rem;
      top: -17rem;
      display: none;

      img {
        width: 14rem;
        height: 14rem;
        transform: rotate(0deg);
        transition: all 0.2s;
      }

      img:hover {
        transform: rotate(90deg);
      }
    }
  }

  li.active {
    font-size: 18rem;
    color: #0bae6a;
  }

  li.active::before {
    content: " ";
    width: calc(100% - 22rem);
    border-top: 2rem solid #0bae6a;
    display: block;
    position: absolute;
    bottom: -9rem;
    left: 11rem;
  }

  li.activeBorder {
    border: 1rem solid #0bae6a;

    .deleteAddCoiling {
      display: block;
    }
  }

  li:focus-visible {
    outline: none;
  }
}

.allCoiling {
  font-size: 14rem;
  color: #a8abb2;
  display: flex;
  align-items: center;

  span {
    display: inline-block;
    font-size: 20rem;
    color: #0bae6a;
    font-weight: 600;
    padding: 0 3rem;
    margin-top: -2rem;

    display: flex;
    justify-content: center;
  }
}

.addCoilingBtn {
  font-size: 16rem;
  color: #0bae6a;
  display: flex;
  align-items: center;
  height: 16rem;
  padding-left: 16rem;
  border-left: 1rem solid #e9e9e9;
  margin-left: 16rem;
  cursor: pointer;

  img {
    width: 16rem;
    height: 16rem;
    margin-right: 3rem;
    margin-top: 2rem;
  }
}

.unsaved {
  width: 8rem;
  height: 8rem;
  position: absolute;
  right: 1rem;
  top: 10rem;
  line-height: 8rem;
  font-size: 14rem;
  color: #ff0000;
}

.previewDialog {
  .preview-header {
    position: absolute;
    top: 16px;
    left: 20px;
    cursor: pointer;
    font-size: 20px;
    color: #a8abb2;
  }

  ::v-deep .el-dialog {
    background-image: linear-gradient(
      188deg,
      #e5f3c7 0%,
      #e6f8e7 14%,
      #ffffff 72%
    );
    border-radius: 10px;
  }

 ::v-deep.el-dialog__body {
    width: 200px;
    padding: 20px 0 0 0;
    margin: 0 auto;
  }

  .coilingNum {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 12px;

    span {
      color: var(--primary-color);
    }
  }

  .coilingQrCode {
    width: 200px;
    height: 200px;
    border: 1px solid #0bae6a85;
    margin: 0 auto;
  }

  .coilingInfo {
    margin: 10px 0 27px 0;
    text-align: center;
    color: #a8abb2;
    font-size: 14px;
  }

  .preserveHandle {
    width: 100%;
    height: 32px;
    padding: 0;
    background-image: var(--background-image);
    border-color: var(--primary-color);
  }

  .dialog-footer {
    display: flex;
    justify-content: center;

    .logo {
      width: 73px;
      height: 14px;
      margin: 20px 0 10px 0;
      background: url(@/assets/images/bottom-logo.png);
      background-size: 100% auto;
    }
  }
}

.pubDialog {
 ::v-deep.el-dialog__body {
    padding: 20rem;
  }

 ::v-deep.el-dialog {
    background: #f5f5f5;
    border-radius: 10rem;
  }

 ::v-deep.el-dialog__title {
    padding-left: 15rem;
    position: relative;
    overflow: hidden;/*超出部分隐藏*/
    text-overflow:ellipsis;/* 超出部分显示省略号 */
    white-space: nowrap;/*规定段落中的文本不进行换行 */
    width: 400rem!important;
    display: inline-block;

    &:before {
      content: "";
      position: absolute;
      // left: 20rem;
      // top: 22rem;
      left: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 5rem;
      height: 20rem;
      border-radius: 10rem;
      background-color: var(--primary-color);
    }
  }

 ::v-deep.el-input__inner:focus {
    border-color: #0bae6a85;
  }

  .dialog-footer {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .preserveHandle {
      width: 76rem;
      height: 32rem;
      padding: 0;
      background-image: var(--background-image);
      border-color: var(--primary-color);

      &.pub {
        background-color: var(--color-danger);
        background-image: var(--color-danger);
        border-color: var(--color-danger);
      }

      &.pub:hover {
        background-color: var(--color-danger);
        background-image: var(--color-danger);
        border-color: var(--color-danger);
      }

      &.cancel {
        background: none;
        color: var(--primary-color);
        border-color: var(--primary-color);
      }

      &.cancel:hover {
        background-image: none;
        border-color: var(--primary-color);
      }
    }

    .preserveHandle:hover {
      width: 76rem;
      height: 32rem;
      padding: 0;
      background-image: var(--background-image);
      border-color: var(--primary-color);
    }
  }

  .select-info {
    margin: 10rem 0;

    .selected {
      margin-left: 10rem;
      color: var(--primary-color);
    }
  }

 ::v-deep.el-checkbox {
    color: #303133;
  }

  ::v-deep.el-checkbox__inner:hover {
    border: 1rem solid #dcdfe6;
  }

 ::v-deep.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }

 ::v-deep.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }

 ::v-deep.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #303133;
  }

  .paper-list {
    background: #fff;
    border: 1rem solid #ededed;
    border-radius: 8rem;

    .title {
      height: 40rem;
      font-size: 16rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1rem solid #ededed;
      font-weight: 700;

      div {
        width: 50%;
        text-align: left;
        padding-left: 50rem;

        &:nth-child(2) {
          padding-left: 92rem;
        }
      }
    }

    .scrollContent {
      height: 328rem;
    }

    .papers {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #666666;
      padding: 25rem;
      box-sizing: content-box;

      .name {
        height: 40rem;

        .paper-name {
          display: flex;
          align-items: center;

          .unsave {
            margin-left: 7rem;
            background: url(@/assets/images/unsave.png);
            background-size: 100% auto;
            color: #ff0000;
            font-size: 12rem;
            width: 47rem;
            height: 20rem;
            line-height: 20rem;
            text-align: center;
          }
        }
      }

      .time {
        height: 40rem;
      }

      .paper-time {
        margin-right: 20rem;
      }
    }
  }
}
</style>

<style lang="scss">
.btnConfirm {
  width: 76rem;
  height: 32rem;
  background: #0bae6a !important;
  color: #fff !important;
  border: 1rem solid #0bae6a !important;
  border-radius: 6rem;
  padding: 0;
}

.btnCancel {
  width: 76rem;
  height: 32rem;
  background: #fff !important;
  color: #0bae6a !important;
  border: 1rem solid #0bae6a !important;
  border-radius: 6rem;
  padding: 0;
}

.customClass {
  width: 439rem !important;
  // height: 160rem !important;
  // padding: 10rem 20rem 0rem 0rem;

  .el-message-box__header .el-message-box__title span {
    margin-left: 20rem;

    &::before {
      content: url("../../assets//images/warning.png");
      position: relative;
      top: 5rem;
      left: -10rem;
    }
  }

  .el-message-box__container .el-message-box__message p {
    margin-left: 47rem;
  }

  .el-message-box__btns {
  }
}

.pubConfirm {
  width: 439rem !important;
  height: auto !important;
  padding: 10rem 20rem 0rem 0rem;
  border-radius: 8rem;

  .el-message-box__header .el-message-box__title span {
    margin-left: 20rem;

    &::before {
      content: url("../../assets//images/warning.png");
      position: relative;
      top: 5rem;
      left: -10rem;
    }
  }

  .el-message-box__container .el-message-box__message p {
    margin-left: 47rem;
  }

  .el-message-box__btns {
    padding: 15rem 0;
  }
}
.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 隐藏表格右侧滚动条 */
.el-table__body-wrapper::-webkit-scrollbar {
  display: none; /* 针对 Webkit 内核浏览器 (Chrome, Safari, Edge) */
}

/* 兼容 Firefox */
.el-table__body-wrapper {
  scrollbar-width: none; /* Firefox */
}

.danger{
  color: #ff0000;
}
.success{
  color: #008000;
}
.warning{
  color: #ff8000;
}
</style>